<pdq-input
  [disabled]="true"
  [formControl]="previewTokenControl"
  label="Copy & paste in checkout form, address2 field for preview bypassing rules"
  tooltip="Short-lived token, refreshed automatically while this page is open"
  [clipboard]="true"></pdq-input>
